import CoursePage from "@components/CoursePage";
import NoSSR from "@mpth/react-no-ssr";
import React from "react";
import { AccessCheck } from "@components/AuthCheck";
import { PageProps, graphql } from "gatsby";

export default function CourseTemplate({
  data: { course },
}: PageProps<Queries.GetCourseQuery>) {
  if (!course) {
    throw new Error("Course not found");
  }

  const coursePage = <CoursePage course={course} />;

  const isPartnerCourse = course.slug.startsWith("partners/");

  return !isPartnerCourse &&
    !course.memberships?.length &&
    (!course.tiers?.length || course.tiers?.includes("ENTERPRISE")) ? (
    coursePage
  ) : (
    <NoSSR>
      <AccessCheck
        memberships={course.memberships}
        tiers={course.tiers}
        isPartnerCourse={isPartnerCourse}
      >
        {coursePage}
      </AccessCheck>
    </NoSSR>
  );
}

export const query = graphql`
  query GetCourse($id: String!) {
    course(id: { eq: $id }) {
      id
      slug
      progressId
      title
      unlisted
      seo {
        title
        description
      }
      version
      date(formatString: "MMM DD, YYYY")
      description
      prerequisites
      memberships
      tiers
      showEnterprisePlanCallout
      thumb {
        src
        alt
      }
      learnings
      type
      status
      changelog
      languages
      taskTypesComingSoon
      relatedCourses {
        ...CourseListing
      }
      authors {
        name
        image
        twitter
      }
      allVersions {
        id
        slug
        progressId
        date(formatString: "MMM DD, YYYY")
        title
        version
        marketoProgramId
        marketoLeadSourceDetail
        memberships
        tiers
        showEnterprisePlanCallout
        changelog
        status
        languages
        lessons {
          slug
          tasks {
            id
          }
        }
      }
      educationLevel
      marketoProgramId
      marketoLeadSourceDetail
      lessons {
        id
        slug
        tasks {
          id
          type
        }
        frontmatter {
          title
          time
          videoId
          conditionalLanguage
          seo {
            title
            description
          }
        }
      }
      certifications {
        id
        slug
        title
        simpleIcon
        courses {
          ...CourseListing
        }
      }
    }
  }

  fragment CourseListing on Course {
    id
    slug
    title
    description
    thumb {
      src
      alt
    }
    type
    featuredBy
    status
    version
    lessons {
      tasks {
        id
      }
    }
  }
`;
